import i18n from '@/i18n'
import { COMPANY_ADMIN_MENU_GROUP_KEY } from '@/constant/company'
import List from './list.vue'
import Layout from '../layout.vue'

const basePath = '/v-admin/employee/management'

export default {
  name: 'employeeManagement',
  path: `${basePath}`,
  redirect: `${basePath}/list`,
  component: Layout,
  meta: {
    isAllInclude: true,
    isNewPage: true,
    permission: ['PERM_REFERRAL_MANAGERMENT', 'COMPUTED_COMPANY_REFERRAL_ENABLED'],
    titleI18nKey: 'admin.company.employeeManagement.title.employeeManagement',
    menu: {
      get label () {
        return i18n.t('admin.company.employeeManagement.title.employeeManagement')
      },
      group: COMPANY_ADMIN_MENU_GROUP_KEY.COMPANY_INTERNAL
    }
  },
  children: [
    {
      path: `${basePath}/list`,
      component: List,
      meta: {
        isNewPage: true,
        breadcrumb: { hidden: true },
        titleI18nKey: 'admin.company.employeeManagement.title.employeeManagement'
      }
    }
  ]
}
